import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from 'lib/utils';

const Switch = React.forwardRef<
	React.ElementRef<typeof SwitchPrimitives.Root>,
	React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
	<SwitchPrimitives.Root
		className={cn(
			// data-[state=unchecked]:bg-muted, no bg-input: --input pasó a valer
			// = --border-strong (defecto 5), un gris pensado para CONTORNOS de
			// 3:1, no para rellenar una pista entera — demasiado marcado como
			// fill. --muted es la superficie "sutil" real (defecto 4).
			//
			// El anillo de foco usa --switch-ring, no --ring: el verde por defecto se confunde
			// con la propia pista cuando el switch está activado. El brillo de hover/active da
			// respuesta al puntero sin cambiar de color.
			'peer inline-flex h-6 w-11 shrink-0 relative before:absolute before:left-1/2 before:top-1/2 before:size-11 before:-translate-x-1/2 before:-translate-y-1/2  cursor-pointer items-center rounded-full border-2 border-transparent transition-colors data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-switch-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background hover:brightness-[0.92] active:brightness-[0.85] disabled:hover:brightness-100 disabled:active:brightness-100 disabled:cursor-not-allowed disabled:opacity-50',
			className
		)}
		{...props}
		ref={ref}
	>
		<SwitchPrimitives.Thumb
			className={cn(
				// El pomo necesita el tono CLARO del tema, no literalmente
				// "background": en claro --background (98%) lo es, pero en oscuro
				// es casi negro y dejaba un pomo invisible sobre la pista.
				// Se apañaba con dark:bg-foreground, que daba el color correcto
				// diciendo algo falso — el pomo no es el color del texto. Ahora es
				// --control-thumb, un token con los mismos dos valores y un nombre
				// que no miente.
				'pointer-events-none block h-5 w-5 rounded-full bg-control-thumb shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0'
			)}
		/>
	</SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
